query hoppermationDefaultSender($companyId: ID!) {
  defaultSender: hoppermationDefaultSender(companyId: $companyId) {
    id
    isVerified
    isAcknowledged
    fromEmail
    name
  }
}
